<template>
  <span class="order-status">
    <v-tooltip right>
      <template v-slot:activator="{ on, attrs }">
          <bx-tag v-if="status == 0"
            ><img
              style="height: 40px; width: 40px"
              src="@/assets/i/gray/pending.svg"
          /></bx-tag>        <div v-bind="attrs" v-on="on">
          <bx-tag v-if="status == 1" color="yellow">{{
            $t("lang.order_status.status_1")
          }}</bx-tag>
          <bx-tag v-if="status == 2"
            ><img
              style="height: 40px; width: 40px"
              src="@/assets/i/triangle-outline.svg"
          /></bx-tag>
          <bx-tag v-if="status == 3"
            ><i class="fa fa-check green-icon"></i
          ></bx-tag>
        </div>
      </template>
      <span>{{ statusTooltip }}</span>
    </v-tooltip>
  </span>
</template>
<script>
export default {
  name: "bx-order-status",
  props: {
    status: {
      type: [Number, String],
      default: 0
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    statusTooltip: {
      get() {
        let text;
        if (this.status === 1) {
          text = this.$t("lang.order_status.status_1");
        } else if (this.status === 2) {
          text = this.$t("lang.order_status.status_2");
        } else if (this.status === 3) {
          text = this.$t("lang.order_status.status_3");
        }
        return text;
      }
    }
  }
};
</script>
